import React, {FC} from "react";
import {Service} from "../redux/types";
import {useUpdateWorkerService} from "../../workers/redux/workers.hook";
import {Checkbox, CircularProgress, FormControlLabel} from "@material-ui/core";

interface WorkerServiceCheckboxProps {
    workerId: string;
    checked: boolean;
    service: Service
}

export const WorkerServiceCheckbox: FC<WorkerServiceCheckboxProps> = ({workerId, service, checked}) => {

    const [isLoading, setIsLoading] = React.useState(false);

    const {addWorkerService, removeWorkerService} = useUpdateWorkerService();

    return (
        <FormControlLabel
            control={
                isLoading
                    ? <CircularProgress color="secondary"/>
                    : (
                        <Checkbox
                            color="primary"
                            checked={checked}
                            onChange={(_event, c) => {
                                setIsLoading(true);
                                c
                                    ? addWorkerService(workerId, service.id).catch(() => {
                                    }).finally(() => setIsLoading(false))
                                    : removeWorkerService(workerId, service.id).catch(() => {
                                    }).finally(() => setIsLoading(false))
                            }}
                        />)

            }
            label={service.name}
        />
    )
}